export default "__VITE_ASSET__CieAs2MT__"